/**
 * Created by Mikhail Menshenin on 16.07.2024
 */

function setShieldsAction() {
    displayToolPrompt((value) => {
        const shields = parseInt(value || "0");
        cleverapps.shields.set(shields);
    }, `Set shields (0...${Shields.MAX_SHIELDS})`, 3);
}

cleverapps.override(cleverapps.Tool.game, {
    attack: function () {
        CoinSlotMachineActions.attack();
    },

    "attack village level": function () {
        const maxVillageLevel = Village.getMaxLevel();
        displayToolPrompt((villageLevel) => {
            villageLevel = villageLevel < 0 ? 0 : villageLevel;
            villageLevel = villageLevel > maxVillageLevel ? maxVillageLevel : villageLevel;
            const player = cleverapps.villagePlayers.getAttackPlayer();
            player.villageLevel = villageLevel;
            cleverapps.villagePlayers.save();
            cleverapps.villagePlayers.attackPlayer = player;
            CoinSlotMachineActions.attack();
            cleverapps.villagePlayers.attackPlayer = undefined;
        }, `raid village level (0...${maxVillageLevel})`, 0);
    },

    raid: function () {
        CoinSlotMachineActions.raid();
    },

    "raid village level": function () {
        const maxVillageLevel = Village.getMaxLevel();
        displayToolPrompt((villageLevel) => {
            villageLevel = villageLevel < 0 ? 0 : villageLevel;
            villageLevel = villageLevel > maxVillageLevel ? maxVillageLevel : villageLevel;
            const player = cleverapps.villagePlayers.getRaidPlayer();
            player.villageLevel = villageLevel;
            cleverapps.villagePlayers.save();
            CoinSlotMachineActions.raid();
        }, `raid village level (0...${maxVillageLevel})`, 0);
    },

    "set shields": setShieldsAction,

    "set energy": function () {
        const slotMachine = aisensia.slotMachine;
        const maxEnergy = slotMachine.getMaxEnergy();
        displayToolPrompt((value) => {
            value = parseInt(value || "0");
            slotMachine.setEnergy(value);
        }, `Set shields (0...${maxEnergy})`, maxEnergy);
    },

    paylines: ToolFolder.create(() => CoinSlotMachine.PAYLINES.reduce((actions, config) => {
        actions[config.payline.join("_")] = function () {
            const slotMachine = aisensia.slotMachine;

            CoinSlotMachine.PREDEFINED_PAYLINE = config.payline;
            slotMachine.spin();
            CoinSlotMachine.PREDEFINED_PAYLINE = undefined;
        };

        return actions;
    }, {}))
});

cleverapps.override(cleverapps.Tool, {
    village: ToolFolder.create(() => {
        const component = VillageSceneComponent.GetRunning();
        const actions = {};

        actions["go to next village"] = function () {
            Village.moveNextLocation();
        };

        if (component) {
            const village = component.village;
            actions["finish one hut"] = function () {
                const hut = village.huts.find((hut) => !hut.isComplete());
                if (hut) {
                    hut.damage = 0;
                    hut.setLevel(hut.getMaxLevel());
                }
            };

            actions["show all huts"] = function () {
                village.huts.forEach((hut) => {
                    if (!hut.level) {
                        hut.setLevel(1);
                    }
                });
            };

            actions["copy hut positions"] = function () {
                const msg = `${village.level}: ${JSON.stringify(cleverapps.styles.HutView.villages[village.level])}`;
                console.log(msg);
                cleverapps.copyToClipboard(msg, () => {
                    cleverapps.notification.create("hut positions copied to clipboard");
                });
            };

            actions["toggle crosses"] = function () {
                cleverapps.flags.toggle("villageCrossEnabled");
            };

            actions["copy cross positions"] = function () {
                const msg = `${village.level}: ${JSON.stringify(cleverapps.styles.CrossView.villages[village.level])}`;
                console.log(msg);
                cleverapps.copyToClipboard(msg, () => {
                    cleverapps.notification.create("cross positions copied to clipboard");
                });
            };

            if (village.debugHutId === undefined) {
                village.debugHutId = -1;
            }
            actions["select next hut"] = function () {
                if (village.debugHutId !== -1) {
                    village.huts[village.debugHutId].cleanupBorder();
                }
                village.debugHutId = (village.debugHutId + 1) % village.huts.length;
                village.huts[village.debugHutId].debugBorder();
            };

            actions["set shields"] = setShieldsAction;

            actions["reset"] = function () {
                if (window.confirm("Reset village progress?")) {
                    Village.moveNextLocation(true);
                }
            };

            return actions;
        }
    }),

    village_attack: ToolFolder.create(() => {
        const actions = {};
        const component = ComponentMap.get(cleverapps.Scenes.GetRunningScene(), VillageAttackSceneComponent);

        if (component) {
            const village = component.village;

            actions["show assault animation"] = function () {
                cleverapps.flags.set("villageAttackMode", "assault");
                village.attackSomeone();
            };
            actions["show defense animation"] = function () {
                cleverapps.flags.set("villageAttackMode", "defense");
                village.attackSomeone();
            };
        }

        return actions;
    })
});

cleverapps.whenAllInitialized(() => {
    if (cleverapps.config.debugMode) {
        ToolModel.AUTONAVIGATE.push({
            windows: [VillageUpgradeWindow],
            path: ["village"]
        });
        ToolModel.AUTONAVIGATE.push({
            filter: function () {
                return cleverapps.toolModel.path === cleverapps.toolModel.root && Boolean(ComponentMap.get(cleverapps.Scenes.GetRunningScene(), VillageAttackSceneComponent));
            },
            path: ["village_attack"]
        });
        ToolModel.AUTONAVIGATE.push({
            filter: function () {
                return cleverapps.toolModel.path === cleverapps.toolModel.root && Boolean(VillageSceneComponent.GetRunning());
            },
            path: ["village"]
        });
    }
});

cleverapps.Tool.Navigation = undefined;
